export const SAVE_SCHEDULE_TIMING_CUSTOMIZE = "SAVE_SCHEDULE_TIMING_CUSTOMIZE"
export const SAVE_SCHEDULE_TIMING_CUSTOMIZE_FAIL = "SAVE_SCHEDULE_TIMING_CUSTOMIZE_FAIL"
export const SAVE_SCHEDULE_TIMING_CUSTOMIZE_SUCCESS = "SAVE_SCHEDULE_TIMING_CUSTOMIZE_SUCCESS"
export const SAVE_SCHEDULE_TIMING_CUSTOMIZE_RESET = "SAVE_SCHEDULE_TIMING_CUSTOMIZE_RESET"

export const saveScheduleTimingCustomize = (params) => {
    return { type: SAVE_SCHEDULE_TIMING_CUSTOMIZE, params }
}
export const saveScheduleTimingCustomizeFail = (response) => {
    // console.log(response)
    return { type: SAVE_SCHEDULE_TIMING_CUSTOMIZE_FAIL, response }
}
export const saveScheduleTimingCustomizeSuccess = (response) => {
    //console.log(response)
    return { type: SAVE_SCHEDULE_TIMING_CUSTOMIZE_SUCCESS, response }
}
export const saveScheduleTimingCustomizeReset = () => {
    return { type: SAVE_SCHEDULE_TIMING_CUSTOMIZE_RESET }
}